<template>
  <div class="product-detail-header-price-component">
    <span class="price-name"
          v-if="!showLabel && price.current.name !== ''"
    >{{ price.current.name }}</span>
    <price :price="price.current.value"
           size="large"
    />
    <price class="price-del"
           v-if="showOriginalPrice"
           :price="price.origin.value"
           size="large"
           :del="true"
    />
    <ym-tag class="benefit-label"
            v-if="showLabel && labelText !== ''"
            type="highlight-light"
            round
            strong
    >
      {{ labelText }}
    </ym-tag>
  </div>
</template>

<script>
  import { Tag } from '@ymba/ym-ui';
  import Price from '@/components/Price';

  export default {
    name: 'ProductDetailPrimaryPrice',
    components: {
      Price,
      YmTag: Tag,
    },
    props: {
      price: {
        require: true,
        type: Object,
      },
    },
    computed: {
      showOriginalPrice() {
        const { benefit, current, origin } = this.price;
        return benefit && benefit.usable && origin.value > current.value;
      },
      labelText() {
        const { benefit } = this.price;
        if (benefit == null) return '';
        const { name, save } = benefit;
        if (name === '') return '';
        return `${name}再减${save}`;
      },
      showLabel() {
        const { benefit } = this.price;
        return benefit && !benefit.usable;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-header-price-component {
    display: flex;
    align-items: flex-end;
  }

  .price-name {
    font-weight: @font-weight-primary;
    font-size: @font-size-base;
    line-height: 1.3;
    color: @price-color-highlight;
    flex-shrink: 0;
    margin-right: @size-small;
  }

  .price-del {
    margin-left: @size-extra-small * 1.5;
    line-height: 1.2;
  }

  .benefit-label {
    margin-left: @size-small;
  }
</style>
